import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal,
  InMemoryInteger,
  InMemoryBoolean
} from "pbas-vue-components";

import { i18n } from '@/plugins/i18n';

function getHeaders() {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "globals.order",
      type: new InMemoryDecimal("Order", {
        getString: (item) => {
          if (item.Order===null || item.Order === undefined) {
            return "";
          }
          return item.Order.toString();
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.class_name",
      type: new InMemoryString("Name", {
        getString: (item) => {
          if (item.Name === undefined || item.Name === null) {
            return "";
          }
          return i18n.t("enums." + item.Name);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.title",
      type: new InMemoryString("Title"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.member_files.size",
      type: new InMemoryInteger("Size"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_item_types.default",
      type: new InMemoryBoolean("Default"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  return headers;
}
export default getHeaders;
